import BaseService from './base.service'

class ReservationService extends BaseService {
    reserve(params) {
        return new Promise((resolve, reject) => {
            return this.request()
                .post({
                    method: 'Reservation.reserve',
                    params,
                })
                .then(response => resolve(response.data?.response))
                .catch(error => reject(this.errorWrapper(error.response)))
        })
    }
}

export default new ReservationService()
